import { Type } from "class-transformer";

export class EmailMessage
{
    constructor
    ( 
        public id: number,
        public recipients: string[],
        public ccs: string[],
        public bccs: string[],
        public subject: string,
        public body: string,
        public from: string,
        public attachmentIds: number[]
        
    )
    {}
}

export class SentEmail extends EmailMessage
{
    constructor
    (
        override id:number,
        override recipients: string[],
        override ccs: string[],
        override bccs: string[],
        override subject: string,
        override body: string,
        override from: string,
        override attachmentIds: number[],
        public sent: boolean,
        public received: boolean,
        public deliveryFailed: boolean,
        public failureType: number,
        public read: boolean,
        dateSent: Date
    )
    {
        super(id,recipients,ccs,bccs,subject,body,from,attachmentIds);
        this.dateSent = dateSent;
        
    }

    @Type(() => Date)
    public dateSent: Date
}

export class ReceivedEmail extends EmailMessage
{
    constructor
    (
        override id:number,
        override recipients: string[],
        override ccs: string[],
        override bccs: string[],
        override subject: string,
        override body: string,
        override from: string,
        override attachmentIds: number[],
        dateReceived: Date,
        public read: boolean

    )
    {
        super(id,recipients,ccs,bccs,subject,body,from,attachmentIds);
        this.dateReceived = dateReceived;
    }

    @Type(() => Date)
    public dateReceived: Date
}


export interface IDraftEmail
{
    recipients: string[];
    subject: string;
    body: string;
    from: string;
    ccs: string[];
    bccs: string[];
    attachmentIds: number[];
    dateLastSaved?: Date;
    id?: number;
    draftEmailRelatedToId?: number;
    draftType?: number;
}

export class DraftEmail implements IDraftEmail
{
    constructor
    (
        public recipients: string[],
        public subject: string,
        public body: string,
        public from: string,
        dateLastSaved?: Date,
        public id?: number,

        public draftEmailRelatedToId?: number,
        public draftType?: number
    )
    {
        if (dateLastSaved)
            this.dateLastSaved = dateLastSaved;
    }

    ccs: string[] = [];
    bccs: string[] = [];
    attachmentIds: number[] = [];

    @Type(() => Date)
    public dateLastSaved?: Date;
    }

export class DraftEmailUpdate
{
    constructor
    (
        public subject?: string,
        public recipients?: string[],
        public body? : string,
        public ccs?: string[],
        public bccs?: string[],
        public from?:string,
        public attachmentIds?:number[]
    )
    {}
}

export class DraftEmailInsert
{
    constructor
    (
        public subject: string,
        public recipients: string[],
        public body? : string,
        public ccs?: string[],
        public bccs?: string[],
        public from?:string,
        public attachmentIds?:number[]
    )
    {}
}

export class EncounterDraftEmail extends DraftEmail
{
    public encounterId!: number;
}

export class ReferralDraftEmail extends DraftEmail
{
    public referralId!: number;
}



export interface ITemplateEmail
{
    templateName: string
    subject: string;
    body: string;
}

export class TemplateEmail implements ITemplateEmail
{
    constructor
    (
        public id: number,
        public templateName: string,
        public subject: string,
        public body: string,
        dateLastSaved: Date
    )
    {
        this.dateLastSaved = dateLastSaved;
    }

    @Type(() => Date)
    public dateLastSaved: Date

    asInsert() : TemplateEmailInsert
    {
        return new TemplateEmailInsert
        (
            this.templateName,
            this.subject,
            this.body
        );
    }
    asUpdate() : TemplateEmailUpdate
    {
        return new TemplateEmailUpdate
        (
            this.templateName,
            this.subject,
            this.body
        );
    }
}

export class TemplateEmailInsert
{
    constructor
    (
        public templateName: string,
        public subject: string,
        public body: string
    )
    {}
}

export class TemplateEmailUpdate
{
    constructor
    (
        public templateName?: string,
        public subject?: string,
        public body?: string
    )
    {}
}